import { Component, Input } from '@angular/core';

/**
 * A circular-arrows "refresh" icon (PRO-1332), inline SVG in the alert-icon
 * mould — the app carries no icon font. It spins while `spinning` is set; the
 * animation lives here rather than on the caller so its keyframes don't add to
 * the dashboard viewer's already-near-budget component stylesheet.
 */
@Component({
  selector: 'app-refresh-icon',
  templateUrl: './refresh-icon.component.html',
  styleUrls: ['./refresh-icon.component.css'],
})
export class RefreshIconComponent {

  // Spin the icon while a refresh is in flight.
  @Input() spinning = false;

}
